import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../lib/supabase';

const MyStoreIntake = ({ refreshUserData, onSignOut }) => {
  const { theme } = useTheme();
  const { user } = useAuth();
  const [businessName, setBusinessName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  const canSubmit = businessName.trim() && description.trim();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit || loading) return;

    setLoading(true);
    try {
      const { error } = await supabase
        .from('users')
        .update({
          intake_completed: true,
          location_data: {
            business_name: businessName.trim(),
            description: description.trim(),
          },
        })
        .eq('auth_id', user.id);

      if (error) throw error;
      refreshUserData();
    } catch (err) {
      console.error('Intake error:', err);
      alert('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: theme.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
    },
    card: {
      width: '100%',
      maxWidth: 440,
    },
    header: {
      marginBottom: 24,
    },
    stepLabel: {
      fontSize: 12,
      fontWeight: 600,
      color: theme.accent,
      textTransform: 'uppercase',
      letterSpacing: 1,
      margin: '0 0 6px',
    },
    title: {
      fontSize: 22,
      fontWeight: 700,
      color: theme.text,
      margin: '0 0 6px',
    },
    subtitle: {
      fontSize: 14,
      color: theme.textSecondary,
      margin: 0,
    },
    fieldGroup: {
      marginBottom: 20,
    },
    label: {
      display: 'block',
      fontSize: 13,
      fontWeight: 600,
      color: theme.text,
      marginBottom: 6,
    },
    required: {
      color: '#ef4444',
    },
    input: {
      width: '100%',
      padding: 12,
      borderRadius: 10,
      border: `1px solid ${theme.border}`,
      backgroundColor: theme.bgInput,
      color: theme.text,
      fontSize: 15,
      boxSizing: 'border-box',
      outline: 'none',
    },
    textarea: {
      width: '100%',
      padding: 12,
      borderRadius: 10,
      border: `1px solid ${theme.border}`,
      backgroundColor: theme.bgInput,
      color: theme.text,
      fontSize: 15,
      boxSizing: 'border-box',
      outline: 'none',
      minHeight: 120,
      resize: 'vertical',
      fontFamily: 'inherit',
    },
    button: {
      width: '100%',
      padding: 14,
      borderRadius: 12,
      border: 'none',
      backgroundColor: theme.accent,
      color: '#fff',
      fontSize: 16,
      fontWeight: 600,
      cursor: 'pointer',
      marginTop: 4,
    },
    buttonDisabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
    signOutBtn: {
      width: '100%',
      padding: 12,
      borderRadius: 10,
      border: `1px solid ${theme.border}`,
      backgroundColor: 'transparent',
      color: theme.textSecondary,
      fontSize: 14,
      cursor: 'pointer',
      marginTop: 12,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <p style={styles.stepLabel}>Step 1 of 3</p>
          <h2 style={styles.title}>Tell Us About Your Store</h2>
          <p style={styles.subtitle}>We need a few details before we can set up your location.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Business Name <span style={styles.required}>*</span>
            </label>
            <input
              type="text"
              placeholder="Your store name"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
              style={styles.input}
              disabled={loading}
            />
          </div>

          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Why would you be a good CardChase location? <span style={styles.required}>*</span>
            </label>
            <textarea
              placeholder="Tell us about your shop, your community, events you host, etc."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={styles.textarea}
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            style={{
              ...styles.button,
              ...(!canSubmit || loading ? styles.buttonDisabled : {}),
            }}
            disabled={!canSubmit || loading}
          >
            {loading ? 'Submitting...' : 'Submit Application'}
          </button>
        </form>

        <button style={styles.signOutBtn} onClick={onSignOut}>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default MyStoreIntake;
